<template>
  <aside v-if="pdfs" class="mt-3">
    <ul class="list-group">
      <li 
        class="list-group-item list-group-item-info text-dark cursor-pointer"
        @click="showPdf(pdfIndex)"
        v-for="(pdf, pdfIndex) in pdfs"
        :key="pdf.id"
      >
        <jet-dialog-modal :id="`pdfModal-${pdfIndex}`" maxWidth="xl" classes="modal-tall pdf-modal" icon="fas fa-print">
          <template #title>View PDF</template>
          <template #content>
            <iframe :src="`${pdf.url}#view=fit#zoom=fitH`" width="100%" class="pdf-frame"></iframe>
          </template>
          <template #footer>
            <jet-button btnStyle="dark" data-dismiss="modal">Close</jet-button>
          </template>
        </jet-dialog-modal>

        <p class="mb-0"><i class="fas fa-file-pdf"></i> View PDF</p>
        <p v-if="pdf.caption" class="text-secondary text-size-small mb-0">{{pdf.caption}}</p>
      </li>
    </ul>
  </aside>
</template>

<script>
  import JetDialogModal from '@/Jetstream/DialogModal'

  export default {
    components: {
      JetDialogModal
    },
    props: {
      pdfs: Object
    },
    methods: {
      showPdf(index) {
        $(`#pdfModal-${index}`).modal('show')
      }
    }
  }
</script>

<style>
  .modal-tall {
    height: 90%;
  }

  .modal-tall div.modal-content {
    height: 100%;
  }

  iframe.pdf-frame {
    width: 100%;
    height: 100%;
    border: none;
  }
</style>

